import { Badge, Col, Row } from "reactstrap";
import { MassageBoxTitle, YouUnderstand } from "../../../Constants/Constants";
import { GalleryImages, Messages } from "../../../Data/Bonus/Elements";
import { dynamicImage, Image } from "../../../Utils";

const MassageBox = () => (
  <section className="massage_box">
    <Col xs="12" className="p-0">
      <div className="element-card">
        <div className="element-card-header heading">
          <h2>{MassageBoxTitle}</h2>
        </div>
        <div className="element-card-body elements-massage typography">
          {Messages.map((group, index) => (
            <ul key={index} className="msg-box fonts">
              {group.map((msg, index) => (
                <li key={index}>
                  <h5 className="bg-primary">{msg}</h5>
                </li>
              ))}
            </ul>
          ))}
          <ul className="msg-box fonts">
            <li className="gallery-img bg-primary">
              <div className="gallery-img-group">
                <Row>
                  {GalleryImages.map((item, index) => (
                    <Col xs="6" key={index}><Image className="img-fluid img-100 gallery-group-{k + 1}" src={dynamicImage(item.src)} alt="Avatar" /></Col>
                  ))}
                </Row>
                <div className="gallery-spinner">
                  <Image className="img-fluid img-100" src={dynamicImage("gif/Loader.gif")} alt="Avatar" />
                </div>
              </div>
              <h4>{YouUnderstand}</h4>
              <Badge color="primary" className="badge-img sm">😍</Badge>
            </li>
          </ul>
        </div>
      </div>
    </Col>
  </section>
);

export default MassageBox;
